import { CalculationOutput } from "../types";
import { PeriodMode, fmtEUR, suffix } from "../utils/period";

export default function MobileKpiStrip({
  output,
  periodMode,
}: {
  output: CalculationOutput | null;
  periodMode: PeriodMode;
}) {
  if (!output) return null;

  const bruto = (output as any).brutoFacturado ?? 0;
  const rendNeto = output.rendimientoNeto ?? 0;
  const irpf = (output as any).irpfTotal ?? output.irpf?.cuotaTotal ?? 0;
  const neto = (output as any).netoFinalTrasRenta ?? output.netoFiscalAnual ?? 0;
  const f = (n: number) => `${fmtEUR(n, periodMode)}${suffix(periodMode)}`;

  return (
    <div className="mobile-kpi-bar">
      <div className="mkpi-item">
        <span className="mkpi-label">Bruto</span>
        <span className="mkpi-value">{f(bruto)}</span>
      </div>
      <div className="mkpi-item">
        <span className="mkpi-label">Rend. neto</span>
        <span className="mkpi-value">{f(rendNeto)}</span>
      </div>
      <div className="mkpi-item">
        <span className="mkpi-label">IRPF</span>
        <span className="mkpi-value warn">{f(irpf)}</span>
      </div>
      <div className="mkpi-item">
        <span className="mkpi-label">Neto final</span>
        <span className="mkpi-value ok">{f(neto)}</span>
      </div>
    </div>
  );
}
